import { create } from "zustand";

interface ExpandStore {
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
}

export const useExpand = create<ExpandStore>((set) => ({
  isExpanded: false,
  setIsExpanded: (isExpanded) => set({ isExpanded }),
}));
